import * as Zustand from "zustand"
import { useShallow } from "zustand/shallow"
import { createStore } from "zustand/vanilla"
import type * as t from "../../shared/types.ts"

export const store = createStore<t.Compute<store.State>>(() => {
  return {
    editingMessageId: undefined,
  }
})

export declare namespace store {
  type State = {
    editingMessageId: string | null | undefined
  }
}

export function useStore<slice = store.State>(
  selector: Parameters<typeof Zustand.useStore<typeof store, slice>>[1] = (
    state,
  ) => state as slice,
) {
  return Zustand.useStore(store, useShallow(selector))
}
